import React, { memo } from 'react';
import Image from 'next/image';

import { IProps } from './model';
import { DEFAULT_ROUTES } from '@mais-retorno-front/constants/routes';

const SOCIAL_NETWORKS = [
  {
    id: 'social-networks-instagram',
    link: DEFAULT_ROUTES.instagramPage,
    title: 'Instagram Mais Retorno',
    icon: '/img/instagram.png',
  },
  {
    id: 'social-networks-youtube',
    link: DEFAULT_ROUTES.youtubeChannel,
    title: 'Youtube Mais Retorno',
    icon: '/img/youtube.png',
  },
  {
    id: 'social-networks-twitter',
    link: DEFAULT_ROUTES.twitterPage,
    title: 'Twitter Mais Retorno',
    icon: '/img/twitter.png',
  },
  {
    id: 'social-networks-facebook',
    link: DEFAULT_ROUTES.facebookPage,
    title: 'Facebook Mais Retorno',
    icon: '/img/facebook.png',
  },
  {
    id: 'social-networks-tiktok',
    link: DEFAULT_ROUTES.tiktokPage,
    title: 'Tiktok Mais Retorno',
    icon: '/img/tiktok.png',
  },
  {
    id: 'social-networks-linkedin',
    link: DEFAULT_ROUTES.linkedinPage,
    title: 'Linkedin Mais Retorno',
    icon: '/img/linkedin.png',
  },
];

export const SocialNetWorks = memo<IProps>(({ iconSize = 20 }) => {
  return (
    <ul className="flex justify-center m-0 p-0 gap-4">
      {SOCIAL_NETWORKS.map((socialNetwork) => (
        <li key={socialNetwork.id}>
          <a
            target="_blank"
            rel="nofollow noopener"
            title={socialNetwork.title}
            href={socialNetwork.link}
            aria-label={socialNetwork.title}
          >
            <Image
              src={socialNetwork.icon}
              alt={socialNetwork.title}
              title={socialNetwork.title}
              height={iconSize}
              width={iconSize}
            />
          </a>
        </li>
      ))}
    </ul>
  );
});
